import React, { Component } from 'react';

import socialHttp from '../../../../utils/socialHttp';

import ReduxConnect from 'Demora/redux-connect';

import {
	Dropdown,
	DropdownItem,
	DropdownMenu,
	DropdownToggle,
} from 'reactstrap';

import Loading from 'Demora/Loading';

import BlockUser from './BlockUser';

import SetNotifications from './SetNotifications';

import GroupSettingsDropdownItem from './GroupSettingsDropdownItem';

import ProfileOptions from 'resources/assets/react-app/uiHooks/react-social/profileOptions';

class EditProfileButton extends Component {
	constructor(props) {
		super();

		this.state = {
			dropdownOpen: false,
			profileSettings: {},
			loaded: false,
		};
	}

	componentDidMount() {
		let props = this.props;

		let obj = props.obj.split('-');

		if (obj[1] !== 'u') {
			this.getData();
		} else {
			this.setState({
				loaded: true,
			});
		}
	}

	componentWillUnmount() {
		this.unmounted = true;
	}

	openProfileSettings = () => {
		this.setState({
			dropdownOpen: !this.state.dropdownOpen,
		});
	};

	getData() {
		socialHttp('get', '/data/feed/' + this.props.obj + '/profileSettings')
			.then((data) => {
				if (!this.unmounted) {
					this.setState({
						profileSettings: data.profile_settings,
						loaded: true,
					});
				}
			})
			.catch((e) => {
				throw e;
			});
	}

	render() {
		const state = this.state;

		const props = this.props;

		const obj = props.obj;

		let dropDownItems = [];

		if (state.loaded) {
			if (obj.split('-')[1] !== 'u') {
				const profileSettings = [
					<DropdownItem key='d1' header>
						Notifications
					</DropdownItem>,
					<DropdownItem key='d2' toggle={false}>
						<SetNotifications
							obj={obj}
							no_notifications={
								!!state.profileSettings.notifications.no_notifications
							}
						/>
					</DropdownItem>,
				];

				if (obj.split('-')[1] == 'g') {
					profileSettings.push(
						<GroupSettingsDropdownItem key='d3' obj={obj} />
					);
				}

				let indexes = {};

				Object.keys(profileSettings).map((b1) => {
					indexes[b1] = 1;
				});

				Object.keys(indexes)
					.sort((a, b) => {
						return a - b;
					})
					.map((k) => {
						if (profileSettings[k]) {
							dropDownItems = dropDownItems.concat(profileSettings[k]);
						}
					});
			} else {
				dropDownItems.push(
					<DropdownItem key='d3' toggle={false}>
						<BlockUser obj={obj} user={obj} />
					</DropdownItem>
				);
			}
		}

		return (
			<div className='text-right'>
				<Dropdown isOpen={state.dropdownOpen} toggle={this.openProfileSettings}>
					<DropdownToggle tag='a' className='btn btn-primary'>
						<i className='fa fa-cog text-white' />
					</DropdownToggle>

					{!state.loaded && (
						<DropdownMenu right style={{ minWidth: '250px' }}>
							<Loading className='mt-4 mb-4' />
						</DropdownMenu>
					)}

					{state.loaded && state.dropdownOpen && (
						<DropdownMenu right style={{ minWidth: '250px' }}>
							{dropDownItems}

							<ProfileOptions obj={obj} />
						</DropdownMenu>
					)}
				</Dropdown>
			</div>
		);
	}
}

export default ReduxConnect(EditProfileButton, {
	user: 'user',
});
